import React, {
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";

import PageLayout from "../../layouts/PageLayout";

import {
  Row,
  Col,
  Form,
  Button,
  Container,
} from "react-bootstrap";

import Select from "react-select";

import { TranslatorContext } from "../../context/Translator";

import {
  Link,
  useNavigate,
} from "react-router-dom";

import axios from "axios";

export default function AddProductPage() {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [categories, setCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [listers, setListers] = useState([]);
  const [mplacers, setMplacers] = useState([]);
  const [brands, setBrands] = useState([]);
  const [stores, setStores] = useState([]);

  const [selectedParentCategory, setSelectedParentCategory] = useState("");

  const [isStudy, setIsStudy] = useState(false);

  const [formData, setFormData] = useState({
    category_id: "",
    lister_id: "",
    mplacer_id: "",
    brand_id: "",
    store_id: "",
    product_condition: "used",
    selling_style: "Fixed",
    title: "",
    short_buying_price: "",
    buying_price: "",
    sell_price_dollar: "",
    auction_min_price: "",
    shipping_charges_dollar: "",
  });

  const [firstImg, setFirstImg] = useState(null);
  const [imgPreview, setImgPreview] = useState(null);

  const [errors, setErrors] = useState({});

  const [cameraOpen, setCameraOpen] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);

  const videoRef = useRef(null);

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    return () => {
      if (cameraStream) {
        cameraStream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [cameraStream]);

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/issuer/products/initial-data`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (response.data.success) {
        const data = response.data.data;
        setCategories(data.categories || []);
        setListers(data.listers || []);
        setMplacers(data.mplacers || []);
        setBrands(data.brands || []);
        setStores(data.stores || []);
      }
    } catch (error) {
      console.error("Error loading initial form data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateBrand = async (brandName) => {
    if (!brandName || !brandName.trim()) return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/issuer/brand`,
        { name: brandName.trim() },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (response.data.success) {
        const newBrand = response.data.data;
        setBrands((prevBrands) => [...prevBrands, newBrand]);
        setFormData((prev) => ({
          ...prev,
          brand_id: newBrand.id,
        }));
        if (errors.brand_id) {
          setErrors((prev) => ({
            ...prev,
            brand_id: null,
          }));
        }
      }
    } catch (error) {
      console.error("Error creating brand:", error);
      alert("Failed to create brand.");
    }
  };

  const handleParentCategoryChange = (selectedOption) => {
    const parentId = selectedOption ? selectedOption.value : "";
    setSelectedParentCategory(parentId);

    const parentCat = categories.find(
      (cat) => cat.id === parseInt(parentId, 10)
    );

    if (parentCat && Array.isArray(parentCat.child_categories)) {
      setChildCategories(parentCat.child_categories);
    } else {
      setChildCategories([]);
    }

    setFormData((prev) => ({
      ...prev,
      category_id: "",
    }));

    if (errors.category_id) {
      setErrors((prev) => ({
        ...prev,
        category_id: null,
      }));
    }
  };

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleSellingStyleChange = (e) => {
    const sellingStyle = e.target.value;
    setFormData((prev) => ({
      ...prev,
      selling_style: sellingStyle,
    }));

    setErrors((prev) => ({
      ...prev,
      selling_style: null,
      auction_min_price: null,
    }));
  };

  const handleStudyChange = (e) => {
    const checked = e.target.checked;
    setIsStudy(checked);

    if (checked) {
      setFormData((prev) => ({
        ...prev,
        sell_price_dollar: "",
      }));
      if (errors.sell_price_dollar) {
        setErrors((prev) => ({
          ...prev,
          sell_price_dollar: null,
        }));
      }
    }
  };

  const openCamera = async () => {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        alert("Camera is not supported by this browser.");
        return;
      }

      stopCamera();

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
        audio: false,
      });

      setCameraStream(stream);
      setCameraOpen(true);

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().catch((error) => console.error("Video play error:", error));
        }
      }, 100);
    } catch (error) {
      console.error("Camera error:", error);
      alert("Unable to open camera.");
    }
  };

  const stopCamera = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach((track) => track.stop());
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setCameraStream(null);
    setCameraOpen(false);
  };

  const capturePhoto = () => {
    const video = videoRef.current;
    if (!video || !video.videoWidth) return;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      if (!blob) return;
      const file = new File([blob], `product-${Date.now()}.jpg`, { type: "image/jpeg" });
      setFirstImg(file);
      setImgPreview(URL.createObjectURL(file));
      stopCamera();
    }, "image/jpeg", 0.9);
  };

  const removeImage = () => {
    setFirstImg(null);
    setImgPreview(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrors({});

    const submitData = new FormData();

    Object.keys(formData).forEach((key) => {
      if (key === "auction_min_price" && formData.selling_style !== "Auction") {
        return;
      }
      if (key === "sell_price_dollar" && isStudy) {
        return;
      }
      if (formData[key] !== null && formData[key] !== "") {
        submitData.append(key, formData[key]);
      }
    });

    if (firstImg) {
      submitData.append("first_img", firstImg);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/issuer/products`,
        submitData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (response.data.success) {
        navigate("/issue-product-list");
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors || {});
      } else {
        alert("Something went wrong while saving the product.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <PageLayout>
        <div className="text-center p-5">
          <div className="spinner"></div>
          <p>Loading Product Setup...</p>
        </div>
      </PageLayout>
    );
  }

  const storeOptions = stores.map((store) => ({ value: store.id, label: store.name }));
  const parentCatOptions = categories.map((cat) => ({ value: cat.id, label: cat.name }));
  const childCatOptions = childCategories.map((child) => ({ value: child.id, label: child.name }));
  const brandOptions = brands.map((brand) => ({ value: brand.id, label: brand.name }));

  const listerOptions = listers.map((lister) => ({
    value: lister.id,
    label: `★ ${lister.nickname} 👤 ${lister.name}`,
    searchText: `${lister.nickname} ${lister.name} ${lister.email || ""}`.toLowerCase(),
  }));

  const mplacerOptions = mplacers.map((mplacer) => ({
    value: mplacer.id,
    searchText: `${mplacer.nickname} ${mplacer.name} ${mplacer.email || ""}`.toLowerCase(),

    label: (
      <div className="d-flex align-items-center justify-content-between w-100">
        <span>
          ★ {mplacer.nickname} 👤 {mplacer.name}
        </span>

        <span
          style={{
            color: mplacer.product_count > 0 ? "#198754" : "#dc3545",
            fontWeight: "600",
            marginLeft: "8px",
          }}
        >
          ({mplacer.product_count})
        </span>
      </div>
    ),
  }));

  const userFilterOption = (option, inputValue) => {
    const search = inputValue.toLowerCase().trim();

    if (!search) return true;

    return option.data.searchText.includes(search);
  };


  return (
    <PageLayout>
      <Container fluid className="px-0">
        <Row>
          <Col xl={12}>
            <div className="mc-card">
              <div className="mc-breadcrumb">
                <h3 className="mc-breadcrumb-title">Add New Product</h3>
                <ul className="mc-breadcrumb-list">
                  <li className="mc-breadcrumb-item">
                    <Link to="#" className="mc-breadcrumb-link">
                      {t("home") || "Home"}
                    </Link>
                  </li>
                  <li className="mc-breadcrumb-item">
                    <Link to="/products" className="mc-breadcrumb-link">
                      {t("products") || "Products"}
                    </Link>
                  </li>
                  <li className="mc-breadcrumb-item">
                    {t("add product") || "Add Product"}
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>

        <Form onSubmit={handleSubmit}>
          <Row>
            <Col lg={8}>
              <div className="mc-card mb-4">
                <h4 className="card-title mb-4">Product Details</h4>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Store <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        isClearable
                        isSearchable
                        placeholder="Select Store..."
                        options={storeOptions}
                        value={storeOptions.find((opt) => opt.value === formData.store_id) || null}
                        onChange={(opt) => handleSelectChange("store_id", opt)}
                        className={errors.store_id ? "is-invalid" : ""}
                      />
                      {errors.store_id && (
                        <div className="text-danger small mt-1">{errors.store_id[0]}</div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Product Condition <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        name="product_condition"
                        value={formData.product_condition}
                        onChange={handleInputChange}
                        isInvalid={!!errors.product_condition}
                      >
                        <option value="new">New</option>
                        <option value="used">Used</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.product_condition && errors.product_condition[0]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Parent Category</Form.Label>
                      <Select
                        isClearable
                        isSearchable
                        placeholder="Select Parent Category..."
                        options={parentCatOptions}
                        value={parentCatOptions.find((opt) => opt.value === parseInt(selectedParentCategory, 10)) || null}
                        onChange={handleParentCategoryChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Sub Category <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        isClearable
                        isSearchable
                        isDisabled={!selectedParentCategory}
                        placeholder="Select Sub Category..."
                        options={childCatOptions}
                        value={childCatOptions.find((opt) => opt.value === formData.category_id) || null}
                        onChange={(opt) => handleSelectChange("category_id", opt)}
                        className={errors.category_id ? "is-invalid" : ""}
                      />
                      {errors.category_id && (
                        <div className="text-danger small mt-1">{errors.category_id[0]}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Title <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    isInvalid={!!errors.title}
                    placeholder="e.g. Rolex Submariner Date 126610LN"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.title && errors.title[0]}
                  </Form.Control.Feedback>
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Brand <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        isClearable
                        isSearchable
                        placeholder="Select Brand..."
                        options={brandOptions}
                        value={brandOptions.find((opt) => opt.value === formData.brand_id) || null}
                        onChange={(opt) => handleSelectChange("brand_id", opt)}
                        noOptionsMessage={({ inputValue }) =>
                          inputValue ? (
                            <div
                              onClick={() => handleCreateBrand(inputValue)}
                              style={{ cursor: "pointer", color: "#0d6efd", fontWeight: "600", display: "flex", alignItems: "center", gap: "4px" }}
                            >
                              <span>+</span> Add "{inputValue}"
                            </div>
                          ) : (
                            "No options"
                          )
                        }
                        className={errors.brand_id ? "is-invalid" : ""}
                      />
                      {errors.brand_id && (
                        <div className="text-danger small mt-1">{errors.brand_id[0]}</div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Selling Style <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        name="selling_style"
                        value={formData.selling_style}
                        onChange={handleSellingStyleChange}
                        isInvalid={!!errors.selling_style}
                      >
                        <option value="Fixed">Fixed</option>
                        <option value="Auction">Auction</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.selling_style && errors.selling_style[0]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Assign Lister</Form.Label>
                      <Select
                        isClearable
                        isSearchable
                        placeholder="Select Lister (Optional)..."
                        options={listerOptions}
                        value={
                          listerOptions.find(
                            (opt) => opt.value === formData.lister_id
                          ) || null
                        }
                        onChange={(opt) => handleSelectChange("lister_id", opt)}
                        filterOption={userFilterOption}
                      />
                      {errors.lister_id && (
                        <div className="text-danger small mt-1">{errors.lister_id[0]}</div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Assign Marketplace User</Form.Label>
                      <Select
                        isClearable
                        isSearchable
                        placeholder="Select Marketplace User (Optional)..."
                        options={mplacerOptions}
                        value={
                          mplacerOptions.find(
                            (opt) => opt.value === formData.mplacer_id
                          ) || null
                        }
                        onChange={(opt) => handleSelectChange("mplacer_id", opt)}
                        filterOption={userFilterOption}
                      />
                      {errors.mplacer_id && (
                        <div className="text-danger small mt-1">{errors.mplacer_id[0]}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              <div className="mc-card mb-4">
                <h4 className="card-title mb-4">Pricing Configuration</h4>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Buying Price PKR <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="buying_price"
                        value={formData.buying_price}
                        onChange={handleInputChange}
                        isInvalid={!!errors.buying_price}
                        placeholder="0.00"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.buying_price && errors.buying_price[0]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Short Buying Price</Form.Label>
                      <Form.Control
                        type="text"
                        name="short_buying_price"
                        value={formData.short_buying_price}
                        onChange={handleInputChange}
                        isInvalid={!!errors.short_buying_price}
                        placeholder="0.00"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.short_buying_price && errors.short_buying_price[0]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Shipping Charges ($) <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="shipping_charges_dollar"
                        value={formData.shipping_charges_dollar}
                        onChange={handleInputChange}
                        isInvalid={!!errors.shipping_charges_dollar}
                        placeholder="0.00"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.shipping_charges_dollar && errors.shipping_charges_dollar[0]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <Form.Label className="mb-0">
                          Selling Price ($) {!isStudy && <span className="text-danger">*</span>}
                        </Form.Label>
                        <Form.Check
                          type="checkbox"
                          id="study-checkbox"
                          label="Study"
                          checked={isStudy}
                          onChange={handleStudyChange}
                          className="small font-weight-bold"
                        />
                      </div>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="sell_price_dollar"
                        value={formData.sell_price_dollar}
                        onChange={handleInputChange}
                        disabled={isStudy}
                        isInvalid={!!errors.sell_price_dollar}
                        placeholder={isStudy ? "Study Mode (Disabled)" : "0.00"}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.sell_price_dollar && errors.sell_price_dollar[0]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {formData.selling_style === "Auction" && (
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Auction Min Price ($)</Form.Label>
                        <Form.Control
                          type="number"
                          step="0.01"
                          name="auction_min_price"
                          value={formData.auction_min_price}
                          onChange={handleInputChange}
                          isInvalid={!!errors.auction_min_price}
                          placeholder="0.00"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.auction_min_price && errors.auction_min_price[0]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  )}
                </Row>
              </div>
            </Col>

            <Col lg={4}>
              <div className="mc-card mb-4">
                <h4 className="card-title mb-4">Main Product Image</h4>
                <div className="text-center mb-3">
                  <Button type="button" variant="dark" className="w-100" onClick={openCamera}>
                    📷 Take Photo
                  </Button>
                </div>

                {imgPreview && (
                  <div className="text-center mt-3">
                    <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                      <img
                        src={imgPreview}
                        alt="Product Preview"
                        className="img-fluid rounded border"
                        style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }}
                      />
                      <Button
                        type="button"
                        variant="danger"
                        size="sm"
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          borderRadius: "50%",
                          width: "32px",
                          height: "32px",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={removeImage}
                      >
                        ×
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              <div className="mc-card">
                <Button type="submit" className="btn btn-primary w-100 mb-2" disabled={submitting}>
                  {submitting ? "Saving Product..." : "Save Product"}
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  className="w-100"
                  onClick={() => navigate("/issue-product-list")}
                  disabled={submitting}
                >
                  Cancel
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Container>

      {cameraOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.92)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "700px",
              backgroundColor: "#000",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "15px",
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 style={{ margin: 0 }}>Take Product Photo</h5>
              <Button type="button" variant="danger" size="sm" onClick={stopCamera}>
                Close
              </Button>
            </div>

            <div
              style={{
                width: "100%",
                background: "#000",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <video
                ref={videoRef}
                autoPlay
                playsInline
                muted
                style={{
                  width: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>

            <div style={{ padding: "20px", display: "flex", gap: "10px" }}>
              <Button type="button" variant="primary" className="w-100" onClick={capturePhoto}>
                📸 Capture Photo
              </Button>
              <Button type="button" variant="secondary" className="w-100" onClick={stopCamera}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
}